import { Pessoa, PessoaEndereco, PessoaJuridica } from '@tivic-team/manager-ts/dist/grl';
import { Concessao } from '@tivic-team/manager-ts/dist/mob/entities/concessao/concessao.entity';

export class ConcessaoColetivoRuralDTO {

    concessao: Concessao = void(0);
    pessoa: Pessoa = void(0);
    pessoaJuridica: PessoaJuridica = void(0);
    pessoaEndereco: PessoaEndereco = void(0);
    lgHabilitacaoAuxiliar: number;
    lgTacografo: number;

    constructor() {}
}